<template>
  <avatar color="accent" :medium="!small" :small="small">
    <v-icon
      color="white"
      class="system-icon material-icons-outlined"
      small
      :x-small="small"
    >
      cloud
    </v-icon>
  </avatar>
</template>

<script>
import Avatar from '@/components/Common/Avatar';
export default {
  name: 'SystemAvatar',
  components: { Avatar },
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.system-icon {
  // Nudge the icon up a bit to center it vertically.
  margin-bottom: 1px;
}
</style>
